import axios from "axios";
import { useState, useEffect } from "react";

const fundamentos = [
  { key: "Service", label: "Saque" },
  { key: "Attack", label: "Ataque" },
  { key: "Block", label: "Bloqueio" },
  { key: "Errors", label: "Erros Adv." },
];

const BasicReports = ({
  partida,
  numSet,
  positionHome,
  score,
  teamNames,
  refreshKey,
  showScoreRow = true,
}) => {
  const [basicReports, setBasicReports] = useState(null);
  const [placar, setPlacar] = useState(null);

  const fetchBasicReports = async () => {
    const response = await axios.post(
      `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/reports/basic-report`,
      { partida, set: parseInt(numSet) }
    );
    setBasicReports(response.data);
  };

  const fetchPlacar = async () => {
    const response = await axios.post(
      `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/reports/placar-set`,
      { partida, set: parseInt(numSet) }
    );
    setPlacar(response.data);
  };

  useEffect(() => {
    fetchBasicReports();
    fetchPlacar();
  }, [partida, numSet, refreshKey]);

  if (!basicReports) {
    return (
      <div className="flex justify-center items-center h-full mt-6">
        <span className="text-gray-600">Carregando estatísticas...</span>
      </div>
    );
  }

  // Placar dos times (estilo igual ao placar geral)
  const renderScoreRow = () => (
    <div className="flex w-full items-center justify-center sticky top-[64px] z-19 mx-auto">
      {/* Nome coluna esquerda */}
      <div className="bg-white shadow h-[30px] min-w-[120px] px-4 flex items-center justify-center text-gray-400 font-bold text-lg border-r-0">
        {positionHome ? teamNames?.home?.name : teamNames?.away?.name}
      </div>
      {/* Placar coluna esquerda */}
      <div
        className={`h-[30px] w-[30px] flex items-center justify-center ${
          positionHome ? "bg-blue-600" : "bg-red-600"
        } text-white text-2l  shadow border-l-0 border-r-0`}
      >
        {positionHome ? placar?.home ?? "-" : placar?.away ?? "-"}
      </div>
      {/* Separador */}
      <span className="mx-1 text-2l  text-gray-400">x</span>
      {/* Placar coluna direita */}
      <div
        className={`h-[30px] w-[30px] flex items-center justify-center ${
          positionHome ? "bg-red-600" : "bg-blue-600"
        } text-white text-2l  shadow border-l-0 border-r-0`}
      >
        {positionHome ? placar?.away ?? "-" : placar?.home ?? "-"}
      </div>
      {/* Nome coluna direita */}
      <div className="bg-white shadow h-[30px] min-w-[120px] px-4 flex items-center justify-center text-gray-400 font-bold text-lg border-l-0">
        {positionHome ? teamNames?.away?.name : teamNames?.home?.name}
      </div>
    </div>
  );

  // Para os fundamentos, também inverter os valores e nomes se necessário
  const renderFundamentoRow = (f) => {
    const leftValue = positionHome
      ? basicReports[f.key]?.[0] ?? "-"
      : basicReports[f.key]?.[1] ?? "-";
    const rightValue = positionHome
      ? basicReports[f.key]?.[1] ?? "-"
      : basicReports[f.key]?.[0] ?? "-";
    return (
      <div
        key={f.key}
        className="flex w-full items-center justify-center"
        style={{ minHeight: 38 }}
      >
        {/* Valor coluna esquerda */}
        <div
          className={`w-[60px] h-[38px] flex items-center justify-center bg-gray-100 text-gray-500 text-sm font-bold shadow`}
        >
          {leftValue}
        </div>
        {/* Nome do fundamento */}
        <div className="bg-white shadow h-[38px] min-w-[120px] px-4 flex items-center justify-center text-gray-400 font-semibold text-sm border-l-0 border-r-0">
          {f.label}
        </div>
        {/* Valor coluna direita */}
        <div
          className={`w-[60px] h-[38px] flex items-center justify-center bg-gray-100 text-gray-500 text-sm font-bold shadow`}
        >
          {rightValue}
        </div>
      </div>
    );
  };

  return (
    <div className="flex flex-col items-center justify-center mt-4 w-full h-[220px]">
      <div className="w-full max-w-xl rounded-lg space-y-2">
        {/* {showScoreRow && renderScoreRow()} */}
        {renderScoreRow()}
        {fundamentos.map(renderFundamentoRow)}
      </div>
    </div>
  );
};

export default BasicReports;
